package dev.mft.website.composable.header

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun Presentation(
    modifierBox: Modifier,
    fontSizeTitle: Float,
    fontSizeParagraph: Float,
    padding: Dp
) {
    BoxWithConstraints(
        modifier = modifierBox,
        contentAlignment = Alignment.Center
    ) {
        val calculatedTitleSize = (maxHeight.value * fontSizeTitle).sp
        val calculatedParagraphSize = (maxHeight.value * fontSizeParagraph).sp

        Card(
            modifier = Modifier
                .fillMaxWidth(0.8f)
                .padding(padding),
            border = BorderStroke(1.dp, Color.Black),
            elevation = CardDefaults.cardElevation(defaultElevation = 4.dp),
            colors = CardDefaults.cardColors(Color.White)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(16.dp),
                verticalArrangement = Arrangement.SpaceEvenly,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    "Hi There!",
                    fontSize = calculatedTitleSize,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center
                )
                Text(
                    "My name is Moreno and I'm a backend developer...\nWelcome to my website made in Kotlin!",
                    fontSize = calculatedParagraphSize,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center
                )
            }
        }
    }
}